import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import api from '../services/api';

const BlogEmailCapture = ({ sourcePage }) => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !email.includes('@')) {
            setStatus('error');
            setMessage('Please enter a valid email address.');
            return;
        }

        setStatus('loading');
        try {
            const res = await api.post('/blog/subscribe', { email, sourcePage });
            setStatus('success');
            setMessage(res.data.message || 'Subscribed! Check your inbox.');
            setEmail('');
        } catch (err) {
            setStatus('error');
            setMessage(err.response?.data?.error || 'Something went wrong. Please try again.');
        }
    };

    if (status === 'success') {
        return (
            <Box sx={{
                background: 'linear-gradient(135deg, #667eea15, #764ba215)',
                borderRadius: 2,
                p: 3,
                textAlign: 'center',
                border: '1px solid #667eea30',
            }}>
                <Alert severity="success" sx={{ mb: 1 }}>
                    {message}
                </Alert>
            </Box>
        );
    }

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                background: '#f8f9fa',
                borderRadius: 2,
                p: 3,
                border: '1px solid #e0e0e0',
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: '#1a1a2e' }}>
                Get speed reading tips in your inbox
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Weekly digest of the best reading techniques and research. No fluff, no spam. Unsubscribe anytime.
            </Typography>
            {status === 'error' && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {message}
                </Alert>
            )}
            <Box sx={{ display: 'flex', gap: 1, flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                <TextField
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={status === 'loading'}
                    sx={{ flex: 1 }}
                />
                <Button
                    type="submit"
                    variant="contained"
                    disabled={status === 'loading'}
                    sx={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        whiteSpace: 'nowrap',
                        px: 3,
                    }}
                >
                    {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
                </Button>
            </Box>
        </Box>
    );
};

export default BlogEmailCapture;
